import { useState } from "react";
import { Button } from "primereact/button";
import { getSocket } from '../context/socket'; // adjust path if needed

const DeleteChecklist = ({ onCancel, togglePopup, cardId, boardId, checklistItemId }) => {
    const socket = getSocket();
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = () => {
        setIsDeleting(true);
        socket.emit('deleteChecklistItem', {
            card_id: cardId,
            checklistItemId: checklistItemId
        });
        onCancel();
    };

    return (
        <div className="popup-box popup-delete">
            <div className="popup-header d-flex justify-content-between align-items-center">
                <span>Delete Task</span>
                <Button icon="pi pi-times" className="p-button-text close-btn" onClick={() => togglePopup("delete")} />
            </div>
            <div className="popup-body">
                <p className="text-danger fw-bold mb-3">
                    Are you sure you want to delete this  <strong>Subtask</strong>?
                    <br />
                    <span className="text-muted">This action is <strong>irreversible</strong>.
                    </span>
                </p>
                <div className="d-flex justify-content-end">
                    <Button
                        label="Cancel"
                        className="border-0 py-1 px-3 me-2 p-button-secondary"
                        onClick={() => onCancel()}
                        disabled={isDeleting}
                    />
                    <Button
                        label="Yes, Delete"
                        severity="danger"
                        className="border-0 py-1 px-3"
                        onClick={handleDelete}
                        disabled={isDeleting}
                    />
                </div>
            </div>
        </div>
    );
};

export default DeleteChecklist
